import LGSdk from '@/utils/languageSDK/index'

export const errorCodeLocales = (code: string): string => {
  const errorCode = LGSdk.t(`errorCode.${code}`)
  if (errorCode) {
    return errorCode
  } else {
    return `errorCode.${code}`// 或者返回一个默认的错误消息
  }
}

export const errorCodeLocalesV2 = (code: string): string => {
  const errorCode = LGSdk.t(`errorCode2.${code}`)
  if (errorCode) {
    return errorCode
  } else {
    return `errorCode2.${code}`// 或者返回一个默认的错误消息
  }
}
